import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { FileWithTask, Theme } from '@df/interfaces';
import {
    EXERCISE_TASK,
    EXERCISE_CALCULATION,
    EXERCISE_MAGIC_BOX,
    EXERCISE_LOGIC,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_SEQUENCE
} from '@app/app.constants';

@Component({
    selector: 'app-summary-modal',
    templateUrl: './summary-data-modal.component.html',
    styleUrls: ['./summary-data-modal.component.scss']
})
export class SummaryModalComponent implements OnInit {
    @Input() selectedFiles: Array<FileWithTask> = [];
    @Input() files: Array<FileWithTask> = [];
    @Input() themes: Array<Theme> = [];

    @Output() closeBtnClicked: EventEmitter<boolean> = new EventEmitter();
    @Output() setSelectedFiles: EventEmitter<Array<FileWithTask>> = new EventEmitter();

    public selectedThemes: Theme[] = [];
    public selectedExerciseTypes: string[] = [];
    public filteredThemes: Theme[] = [];
    public filteredFiles: FileWithTask[] = [];

    themeString: string = '';
    titleString: string = '';

    public exerciseTypes = {
        [EXERCISE_TASK]: 'задача',
        [EXERCISE_CALCULATION]: 'пример',
        [EXERCISE_MAGIC_BOX]: 'магический квадрат',
        [EXERCISE_LOGIC]: 'логическая задача',
        [EXERCISE_PUZZLE_TASK]: 'ребус задача',
        [EXERCISE_PUZZLE_EXAMPLE]: 'ребус пример',
        [EXERCISE_SEQUENCE]: 'последовательность'
    };

    objectKeys = Object.keys;

    constructor() {}

    public ngOnInit(): void {
        this.themes.sort((theme1, theme2): number => {
            return theme1.number > theme2.number ? 1 : -1;
        });
        this.filteredThemes = this.themes.slice();
        this.filteredThemes.sort((theme1, theme2): number => {
            return theme1.number > theme2.number ? 1 : -1;
        });
        this.filteredFiles = this.files.slice();
        this.selectedFiles = this.selectedFiles.slice();
    }

    filterFiles() {
        this.filteredFiles = this.files.filter(file => {
            if (this.selectedThemes.length) {
                let isThemeExists = false;
                for (const t of this.selectedThemes) {
                    if (file.theme) {
                        if (file.theme.id === t.id) {
                            isThemeExists = true;
                            break;
                        }
                    }
                }
                // Theme does not match selected topics
                if (!isThemeExists) {
                    return false;
                }
            }

            if (this.selectedExerciseTypes.length) {
                let isTypeExists = false;

                for (const t of this.selectedExerciseTypes) {
                    if (file.type === t) {
                        isTypeExists = true;
                        break;
                    }
                }

                if (!isTypeExists) {
                    return false;
                }
            }

            if (this.titleString.length > 0) {
                if (file.str_title.indexOf(this.titleString) === -1) {
                    return false;
                }
            }

            return true;
        });
    }

    close() {
        this.closeBtnClicked.emit(true);
    }

    save() {
        this.setSelectedFiles.emit(this.selectedFiles);
        this.close();
    }

    isThemeSelected(theme: Theme) {
        return this.selectedThemes.indexOf(theme) > -1;
    }

    processTitleSearch() {
        this.filterFiles();
    }

    filterThemes() {
        const _filter = this.themeString.trim().toLowerCase();
        this.filteredThemes = this.themes.filter((theme: Theme) => theme.title.toLowerCase().includes(_filter));
    }

    isFileSelected(file: FileWithTask) {
        return this.selectedFiles.indexOf(file) > -1;
    }

    toggleTheme(theme: Theme) {
        const idx = this.selectedThemes.indexOf(theme);
        if (idx === -1) {
            this.selectedThemes.push(theme);
        } else {
            this.selectedThemes.splice(idx, 1);
        }
        this.filterFiles();
    }

    toggleType(type: string) {
        const idx = this.selectedExerciseTypes.indexOf(type);
        if (idx === -1) {
            this.selectedExerciseTypes.push(type);
        } else {
            this.selectedExerciseTypes.splice(idx, 1);
        }
        this.filterFiles();
    }

    removeFile(idx: number) {
        this.selectedFiles.splice(idx, 1);
    }

    selectFile(file: FileWithTask) {
        if (this.selectedFiles.indexOf(file) !== -1) {
            return;
        }
        this.selectedFiles.push(file);
    }
}
